import { render } from "./GroupClassReport.vue?vue&type=template&id=2feb479d&scoped=true"
import script from "./GroupClassReport.vue?vue&type=script&lang=js"
export * from "./GroupClassReport.vue?vue&type=script&lang=js"

import "./GroupClassReport.vue?vue&type=style&index=0&id=2feb479d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feb479d"]])

export default __exports__